<template>
  <div class="pa-times-infomation-card" v-if="infomation">
    <p class="date" :class="additionalClass.date">{{infomation.date}}</p>
    <p class="main-text" :class="additionalClass.mainText">{{infomation.title}}</p>
    <p class="sub-text" :class="additionalClass.subText">{{infomation.summary}}</p>
  </div>
</template>

<script>
import {GetInfomation} from '@/graphql/queries/Infomation.graphql'

export default {
  props : {
    infomationId : {
      default: null
    }
  },

  data(){
    return {
      additionalClass : {
        date      : {
          'is-readed' : false
        },
        
        mainText  : {
          'is-readed' : false
        },

        subText   : {
          'is-readed' : false
        }
      }
    };
  },

  apollo : {
    infomation : {
      query : GetInfomation,
      variables(){
        return {
          id  : this.infomationId
        }
      },
      skip(){
        if(this.infomationId === null){
          return true;
        }else{
          return false;
        }
      }
    }
  },

  watch : {
    infomation : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        if(data.characterReaded === true){
          this.additionalClass.date['is-readed']      = true;
          this.additionalClass.mainText['is-readed']  = true;
          this.additionalClass.subText['is-readed']   = true;
        }else{
          this.additionalClass.date['is-readed']      = false;
          this.additionalClass.mainText['is-readed']  = false;
          this.additionalClass.subText['is-readed']   = false;
        }
      },
      immediate: true
    }
  }
  
}
</script>

<style lang="scss">
.pa-times-infomation-card{
  user-select: none;

  p.date{
    font-size:.9rem;
    border-radius: 12px;
    text-align: center;
    width:30vw;
    background-color:#6D1B36;

    &.is-readed{
      color:#BF9DA6  !important;
      background-color:#77314E !important;
    }
  }

  p.main-text, p.sub-text{
    font-size: .95rem;
    width:98%;
    margin:.2rem auto;

    &.is-readed{
      // color:#9D7C7C;
      // color:#A26262;
      color:#BDAAAA  !important;
    }
  }

  p.sub-text{
    font-size: .9rem;
    color:#b58fa0;

    &.is-readed{
      color:#A88293  !important;
    }
  }

  &:last-child{
    border-bottom:0;
  }

  &:active{
    p.sub-text{
      color:#C6A2B2;
    }
    p.date{
      background-color: #802342;
    }
  }
}
</style>